import { apiFetch } from './api';

export interface Novidade {
  id: string;
  titulo: string;
  descricao: string;
  conteudo: string;
  dataLancamento?: string;
  destaque: boolean;
  ordem: number;
  isBanner: boolean;
  bannerExpirationDate?: string;
  active: boolean;
  creationTime?: string;
  lastUpdateTime?: string;
}

export interface NovidadeRQ {
  titulo: string;
  descricao: string;
  conteudo: string;
  dataLancamento?: string;
  destaque: boolean;
  ordem: number;
  isBanner: boolean;
  bannerExpirationDate?: string;
}

export const novidadesApi = {
  getAll: async (): Promise<Novidade[]> => {
    return apiFetch<Novidade[]>('/Novidade/GetAll', { auth: true });
  },

  getActive: async (): Promise<Novidade[]> => {
    return apiFetch<Novidade[]>('/Novidade/GetActive', { auth: true });
  },

  getHighlighted: async (): Promise<Novidade[]> => {
    return apiFetch<Novidade[]>('/Novidade/GetHighlighted', { auth: true });
  },

  getById: async (id: string): Promise<Novidade> => {
    return apiFetch<Novidade>(`/Novidade/Get/${id}`, { auth: true });
  },

  create: async (novidade: NovidadeRQ): Promise<Novidade> => {
    return apiFetch<Novidade>('/Novidade/Create', {
      method: 'POST',
      auth: true,
      body: JSON.stringify(novidade),
    });
  },

  update: async (id: string, novidade: NovidadeRQ): Promise<Novidade> => {
    return apiFetch<Novidade>(`/Novidade/Update/${id}`, {
      method: 'PUT',
      auth: true,
      body: JSON.stringify(novidade),
    });
  },

  delete: async (id: string): Promise<void> => {
    return apiFetch<void>(`/Novidade/Delete/${id}`, {
      method: 'DELETE',
      auth: true,
    });
  },

  getActiveBanner: async (): Promise<Novidade | null> => {
    try {
      return await apiFetch<Novidade>('/Novidade/GetActiveBanner', { auth: true });
    } catch (error: any) {
      if (error.status === 404) {
        return null;
      }
      throw error;
    }
  },
};

